import { render, staticRenderFns } from "./RequestADemo.vue?vue&type=template&id=644e86d5&scoped=true"
import script from "./RequestADemo.vue?vue&type=script&lang=js"
export * from "./RequestADemo.vue?vue&type=script&lang=js"
import style0 from "./RequestADemo.vue?vue&type=style&index=0&id=644e86d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644e86d5",
  null
  
)

export default component.exports